"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mask_1 = require("../mask");
var validator = require("../validator");
var config = {};
function getConfig() {
    return config;
}
exports.getConfig = getConfig;
function setConfig(customConfig) {
    config = customConfig;
    mask_1.register(customConfig.masks || []);
    configValidation(customConfig.validation);
}
exports.setConfig = setConfig;
function configValidation(config) {
    if (!config)
        return;
    if (config && config.customMessages) {
        validator.addLang(config.lang, config.customMessages);
    }
    validator.useLang(config.lang);
}
//# sourceMappingURL=index.js.map